//
// events fired by SRG-Login client class
// implementing feature must listen to these events
//
export const SRG_LOGIN_LOGGED_IN = 'srgLogin:loggedIn';

export const SRG_LOGIN_LOGGED_OUT = 'srgLogin:loggedOut';

export const SRG_LOGIN_INITIAL = 'srgLogin:initialLogin';

//
// events fired by login-bound features to initiate SRG-Login action
//
export const SRG_LOGIN_CHECK_SESSION = 'srgLogin:checkSession';

export const SRG_LOGIN_TRIGGER_LOGIN = 'srgLogin:triggerLogin';

export const SRG_LOGIN_TRIGGER_LOGOUT = 'srgLogin:triggerLogout';

export const SRG_LOGIN_TRIGGER_REGISTRATION = 'srgLogin:openRegistrationPage';

export const SRG_LOGIN_OPEN_PROFILE_PAGE = 'srgLogin:openProfilePage';
